// extracted by mini-css-extract-plugin
module.exports = {"tooltip-trigger":"style_tooltip-trigger__r4c6_"};